import { collection, getDocs, query, orderBy, where } from 'firebase/firestore';
import { db } from '../../config';
import { DictionaryType } from '../../../../types/dictionary';
import { masterStatus } from '../../../../constants/enum';

export const getDictionariesByCompanyId = async (companyId: string): Promise<DictionaryType[]> => {
  const dictionariesRef = collection(db, 'dictionaries');
  const q = query(
    dictionariesRef,
    where('company_id', '==', companyId),
    orderBy('updated_at', 'desc'),
  );
  const snapshot = await getDocs(q);

  // 論理削除済み（status=99）の辞書は一覧から除外する。
  return snapshot.docs
    .map(doc => ({
      dictionary_id: doc.id,
      ...doc.data(),
    }))
    .filter(d => (d as DictionaryType).status !== masterStatus.deleted) as DictionaryType[];
};
